import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { AuthenticationService } from '../../../services/authentication.service'
import { ActivatedRoute, Router } from '@angular/router'
import { TabsetComponent } from 'ngx-bootstrap/tabs'
import { Merchant } from '@parkupp/core'
import { MerchantService } from '../../../services/merchant.service'
import { ToastrService } from 'ngx-toastr'

@Component({
    selector: 'app-merchant-profile-tabs',
    templateUrl: './merchant-profile-tabs.component.html',
    styleUrls: ['./merchant-profile-tabs.component.scss'],
})
export class MerchantProfileTabsComponent implements OnInit {
    @Input() merchant: Merchant

    dashboardView: boolean
    tab: any
    securityPhoneNumbers: string = ''
    private securityLoaded = false

    constructor(
        private activatedRoute: ActivatedRoute,
        public authService: AuthenticationService,
        public router: Router,
        private merchantService: MerchantService,
        private toastrService: ToastrService
    ) {
        this.activatedRoute.params.subscribe((params) => {
            if (params['tab']) {
                this.tab = params['tab']
            } else {
                this.tab = 'details'
            }
            console.log('Tab parameter:', this.tab)
        })
        this.dashboardView = true
    }

    ngOnInit(): void {}

    ngOnChanges(): void {
        if (this.merchant && !this.securityLoaded) {
            this.securityPhoneNumbers = (this.merchant as any).securityPhoneNumbers || ''
            this.securityLoaded = true
        }
    }

    ngAfterViewInit(): void {
        if (this.tab) {
            if (this.tab === 'managers') {
                const tabButton = document.querySelector('#tabs li:nth-child(2) a')
                if (tabButton) {
                    // @ts-ignore
                    tabButton.click()
                }
            }
            if (this.tab === 'payout') {
                const tabButton = document.querySelector('#tabs li:nth-child(3) a')
                if (tabButton) {
                    // @ts-ignore
                    tabButton.click()
                }
            }
        }
    }

    saveSecurityPhoneNumbers() {
        this.merchantService
            .updateMerchant({ securityPhoneNumbers: this.securityPhoneNumbers.trim() }, this.merchant.$key!)
            .then(() => {
                this.toastrService.success('Security guard phone numbers saved', 'Successful')
            })
            .catch((error: any) => {
                this.toastrService.error(error.message || 'Failed to save security phone numbers', 'Error')
            })
    }
}
